<script lang="ts" setup>
import type { CollapseProps } from 'naive-ui'
import { NCollapse } from 'naive-ui'
import CIcon from '../CIcon/CIcon.vue'
import { merge } from 'lodash-es'
import { useAttrs } from 'vue'

interface Props {
  floatArrowRight?: boolean
  size?: 'small' | 'medium'
}

const attrs: CollapseProps = useAttrs()

const defaultAttrs: CollapseProps = {
  arrowPlacement: 'right',
}

const props = withDefaults(defineProps<Props>(), {
  floatArrowRight: true,
  size: 'medium',
})

const mergedAttrs: CollapseProps = merge(defaultAttrs, attrs)
</script>

<template>
  <NCollapse
    v-bind="mergedAttrs"
    class="c-collapse"
    :class="{ 'c-collapse--small': props.size === 'small', 'c-collapse--float-arrow': props.floatArrowRight }"
  >
    <slot />
    <template #header-extra>
      <slot name="header-extra" />
    </template>
    <template #arrow>
      <slot name="arrow">
        <CIcon fa-type="far" icon="chevron-right" />
      </slot>
    </template>
  </NCollapse>
</template>

<style lang="scss" scoped>
.c-collapse {
  &--float-arrow {
    :deep(.n-collapse-item__header .n-collapse-item__header-main .n-collapse-item-arrow) {
      margin-left: auto;
      font-size: 24px;
      line-height: 24px;
    }
  }

  &--small {
    :deep(.n-collapse-item__header .n-collapse-item__header-main .n-collapse-item-arrow) {
      font-size: 14px;
      line-height: 14px;
    }
  }

  :deep(.n-collapse-item__header-main) {
    padding: 16px 8px;
    line-height: 1.3125rem;
  }
}
</style>
